import { useContext } from 'react';
import { EnvironmentContext } from './environment-context';
export var useEnvironment = function () {
    var environmentName = useContext(EnvironmentContext).environmentName;
    return environmentName;
};
